/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./icon-language.vue?vue&type=template&id=149759ea&scoped=true&"
import script from "./icon-language.vue?vue&type=script&lang=ts&"
export * from "./icon-language.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149759ea",
  null
  
)

export default component.exports